// API URLs carry this placeholder; the request context swaps in the current company slug.
export const COMPANY_SLUG_PLACEHOLDER = '{currentCompanySlug}'

export const CURRENT_COMPANY_SLUG_STORAGE_KEY = 'currentCompanySlug'
